// Client for the searchYouTubeVideos Cloud Function — keeps the YouTube API key server-side.

export interface YouTubeSearchResult {
  videoId: string;
  title: string;
  channelTitle: string;
  thumbnailUrl: string;
}

interface YouTubeSearchApiResponse {
  results?: YouTubeSearchResult[];
  error?: string;
}

const getFunctionsBaseUrl = (): string => {
  const value = process.env.REACT_APP_FUNCTIONS_URL?.trim();
  if (!value) {
    throw new Error('YouTube search is unavailable right now. Please try again shortly.');
  }
  return value.replace(/\/$/, '');
};

export async function searchYouTubeVideos(query: string): Promise<YouTubeSearchResult[]> {
  const trimmed = query.trim();
  if (!trimmed) return [];

  const url = `${getFunctionsBaseUrl()}/searchYouTubeVideos?q=${encodeURIComponent(trimmed)}`;
  const response = await fetch(url);
  const data = (await response.json()) as YouTubeSearchApiResponse;

  if (!response.ok) {
    throw new Error(data.error || 'YouTube search failed. Please try again.');
  }

  return Array.isArray(data.results) ? data.results : [];
}
